import { useQuery } from '@tanstack/react-query'
import { reactQueryKeys } from 'reactQueryKeys/reactQueryKeys'
import { getEarnAssetDetails } from 'services/EarnService'

export const useEarnDetailsQuery = (portfolioId?: string) => {
  return useQuery({
    queryKey: reactQueryKeys.earnAssetDetails(portfolioId ?? ''),
    queryFn: () => getEarnAssetDetails(portfolioId ?? ''),
    enabled: !!portfolioId,
  })
}
